import { formatNumber } from '@/lib/utils'

/** A tax rate held as a percent ("8.2500") -> "8.25%". */
export function formatTaxRate(percent: string | number | null | undefined): string {
  if (percent == null || percent === '') return '—'
  return `${formatNumber(percent, 3)}%`
}

/** A tax rate held as a fraction ("0.082500") -> "8.25%". */
export function formatRateFraction(fraction: string | number | null | undefined): string {
  if (fraction == null || fraction === '') return '—'
  return formatTaxRate(Number(fraction) * 100)
}

export const STATE_NAMES: Record<string, string> = {
  AK: 'Alaska', AL: 'Alabama', AR: 'Arkansas', AZ: 'Arizona', CA: 'California', CO: 'Colorado',
  CT: 'Connecticut', DC: 'District of Columbia', DE: 'Delaware', FL: 'Florida', GA: 'Georgia',
  HI: 'Hawaii', IA: 'Iowa', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', KS: 'Kansas',
  KY: 'Kentucky', LA: 'Louisiana', MA: 'Massachusetts', MD: 'Maryland', ME: 'Maine',
  MI: 'Michigan', MN: 'Minnesota', MO: 'Missouri', MS: 'Mississippi', MT: 'Montana',
  NC: 'North Carolina', ND: 'North Dakota', NE: 'Nebraska', NH: 'New Hampshire', NJ: 'New Jersey',
  NM: 'New Mexico', NV: 'Nevada', NY: 'New York', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon',
  PA: 'Pennsylvania', PR: 'Puerto Rico', RI: 'Rhode Island', SC: 'South Carolina',
  SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VA: 'Virginia', VT: 'Vermont',
  WA: 'Washington', WI: 'Wisconsin', WV: 'West Virginia', WY: 'Wyoming',
}

/** "All states" / "All but Hawaii" / "Missing Hawaii and Ohio" for a delivery's coverage. */
export function coverageLabel(missing: string[]): string {
  if (!missing.length) return 'All states'
  const names = missing.map((code) => STATE_NAMES[code] ?? code)
  if (names.length === 1) return `All but ${names[0]}`
  return `Missing ${names.slice(0, -1).join(', ')} and ${names.at(-1)}`
}
